import React from "react"

import NotificationContainer from "components/NotificationContainer"

import Modal from "./Modal"

const StudentMessagingDisabled = ({
  organizationId,
  studentMessagingDisabled,
}) => {
  return (
    <>
      <NotificationContainer />
      <Modal
        organizationId={organizationId}
        studentMessagingDisabled={studentMessagingDisabled}
      />
    </>
  )
}

export default StudentMessagingDisabled
